import React from 'react';
import {FlexContainer} from 'app/styles/content';
import {
  Content,
  Container,
  DataContainer,
  ImageContainer,
  GoalInformation,
} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS, Image, Typography} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import MatchEventMinute from 'app/components/matchEvents/MatchEventMinute';
import ProfileImageFallbackIcon from 'app/styles/ProfileImageFallbackIcon';

const MatchEventTimepenalty = ({event}) => {
  const highlightColor = COLORS.red;

  const checkImage =
    event.primaryRole && event.primaryRole.player.image ? (
      <Image entity='player' src={event.primaryRole.player.image} ratio='1:1' width={64} height={64} circle={true} />
    ) : (
      <ProfileImageFallbackIcon />
    );
  const standingMessage = `Zeitstrafe ⏱️ für ${event.team.name.middle}`;
  const checkEventLength = event.length > 1 ? `Dauer: ${event.length} Minuten` : `Dauer: ${event.length} Minute`;
  const duration = event.length ? <Typography variant='caption1'>{checkEventLength}</Typography> : null;
  const reason = event.text ? <Typography variant='caption1'>Grund: {event.text}</Typography> : null;
  const playerName = event.primaryRole
    ? event.primaryRole.player.firstName + ' ' + event.primaryRole.player.lastName
    : 'Unbekannt';
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;

  const mainContent = (
    <FlexContainer>
      <ImageContainer>{checkImage}</ImageContainer>
      <GoalInformation>
        <Typography variant='body1'>{standingMessage}</Typography>
        <Typography variant='body2'>{playerName}</Typography>
        {duration}
        {reason}
      </GoalInformation>
    </FlexContainer>
  );

  const primaryRole = event.primaryRole ? (
    <LinkOnComponent to={`/player/${event.primaryRole.player.slug}`}>{mainContent}</LinkOnComponent>
  ) : (
    mainContent
  );

  return (
    <Content>
      <Container>
        <MatchEventMinute minute={time} customBgColor={highlightColor} />
        <DataContainer style={{borderLeft: `1px solid ${highlightColor}`}}>{primaryRole}</DataContainer>
      </Container>
    </Content>
  );
};

export default MatchEventTimepenalty;
